export type Link = typeof link;

export const link = {
  CONSOLE_PRIVACY_POLICY: `https://console.upstage.ai/docs/resources/terms-and-policies/privacy-policy`,
  CONSOLE_TERMS_AND_POLICIES: `https://console.upstage.ai/docs/resources/terms-and-policies/terms-of-use`,
  CONSOLE_PROMOTION: `https://www.upstage.ai/policies/marketing-terms`,
  BUSINESS_INFORMATION: `https://upstage.notion.site/0e38f4cd2e0346d0b996df4b80ad667d`,
  SERVICE_UPDATES: "https://upstage.gitbook.io/notice/",
  ELFSIGHT: {
    SUBMIT_FORM: `https://data.elfsight.com/public/resources/form-submissions/`,
  },
  FAQS: `https://upstage.gitbook.io/console/help-center/faqs`,
  PRICING: "https://www.upstage.ai/pricing",
  DELETE_ACCOUNT:
    "https://agi4work.atlassian.net/servicedesk/customer/portal/7/create/10089",
  HOME_TERMSANDPRIVACY: "/docs/resources/terms-and-policies/privacy-policy",
  SUPPORT:
    "https://get.support.upstage.ai/servicedesk/customer/topic/7b8ef8be-ec39-43f4-80d4-eff9fbe25eaf",
  FEEDBACK:
    "https://get.support.upstage.ai/servicedesk/customer/portal/22/create/10440",
  GLOBAL: "https://upstage.ai",
};
